import { FC, JSX } from 'react';
import { Text } from '@connect-x-app/hybrid-ui';
import { COLORS } from '@connect-x-app/shared-ui';
import { ADMIN_TEST_IDS } from '@connect-x-app/web-test-ids';

import './emptyState.scss';

type Props = {
  button?: () => JSX.Element | null;
  description: string;
  title: string;
};
export const EmptyState: FC<Props> = ({ button: Button, description, title }) => {
  return (
    <main className="content-container" data-test={ADMIN_TEST_IDS.shared.emptyState}>
      <div className="content">
        <Text as="span" color={COLORS.zulu.$08} size="LG" uppercase weight="bold">
          {title}
        </Text>
        <Text as="span" className="description" color={COLORS.zulu.$06} size="MD" weight="regular">
          {description}
        </Text>
        {Button ? <Button /> : <></>}
      </div>
    </main>
  );
};
